import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { filter, switchMap, take, tap } from 'rxjs/operators';

import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';

import { AppRoutePath } from '@cdba/app-route-path.enum';
import { EmptyStatesPath } from '@cdba/core/empty-states/empty-states-path.enum';

import { RoleFacade } from '../../role-facade/role.facade';

@Injectable({
  providedIn: 'root',
})
export class DescriptiveRoleGuard {
  private readonly router = inject(Router);
  private readonly roleFacade = inject(RoleFacade);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  canActivate(): Observable<boolean> {
    return this.hasDescriptiveRoles();
  }

  canActivateChild(): Observable<boolean> {
    return this.hasDescriptiveRoles();
  }

  private hasDescriptiveRoles(): Observable<boolean> {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      take(1),
      switchMap(() => this.roleFacade.hasDescriptiveRoles$),
      tap((hasDescriptiveRoles) => {
        if (!hasDescriptiveRoles) {
          this.router.navigate([
            AppRoutePath.EmptyStatesPath,
            EmptyStatesPath.MissingRolesPath,
          ]);
        }
      })
    );
  }
}
